module.exports = __webpack_public_path__ + "img/Upload.cde16ee7.svg";